export const MAX_WRAPPER_SIZE = '1440px';

export const FRAME_MOBILE_SIZE = {
    xl: '1372px',
    xxl: '1455px',
};

export const PAY_STATUSES = {
    success: 'Подтвержден',
    reserved: 'Зарезервирован',
    remaining: 'Ожидает оплаты',
};
